import { useCallback, useEffect, useState } from 'react';

/** Live data hook — loading, error, refetch (no mock fallback). */
export function useLiveData(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const result = await fetcher();
      setData(result);
    } catch (e) {
      const msg = e.message === 'Failed to fetch'
        ? 'Network slow — tap Retry. Your login stays active.'
        : (e.message || 'Failed to load');
      setError(msg);
      // Keep previous data visible on refresh errors
    } finally {
      setLoading(false);
    }
  }, deps);

  useEffect(() => {
    reload();
  }, [reload]);

  return { data, loading, error, reload };
}

let searchTimer;
export function useDebouncedSearch(callback, delay = 350) {
  return useCallback(
    (value) => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => callback(value), delay);
    },
    [callback, delay]
  );
}
